import novaTheme from "@/styles/novaTheme";
import { css } from "@emotion/react";

export const selectCss = css`
  height: 48px;

  .ant-select-selector {
    border-radius: 6px;
    min-width: 100%;
    border: 0.5px solid ${novaTheme.colors.blueGray200Light};

    .ant-select-selection-search {
      margin-top: 10px;
    }
  }

  .ant-select-clear {
    right: 50px;
    font-size: 15px;
  }

  .ant-select-arrow {
    top: 18px;
    width: 23.86px;
    height: auto;
  }

  .ant-select-selection-item:after {
    margin-top: 9px;
  }

  .ant-select-selection-placeholder {
    margin-top: 8px;
  }

  .ant-select-item.ant-select-item-option {
    overflow: hidden;
  }
`;
